import { cn, formatMoney } from '@/lib/utils'

export interface AmountRow {
  label: string
  amount: string | number
  /** Bold the amount (the figure the row exists for). */
  strong?: boolean
  /** Grey the amount (nothing outstanding). */
  muted?: boolean
}

/** A dense label / amount list: label left and muted, amount right in tabular figures. */
export function AmountList({ rows, className }: { rows: AmountRow[]; className?: string }) {
  return (
    <dl className={cn('grid grid-cols-[minmax(0,1fr)_auto] gap-x-4 gap-y-1 text-sm', className)}>
      {rows.map((row) => (
        <div key={row.label} className="contents">
          <dt className="truncate text-muted-foreground">{row.label}</dt>
          <dd
            className={cn(
              'text-right tabular-nums',
              row.strong ? 'font-semibold' : 'font-medium',
              row.muted && 'text-muted-foreground',
            )}
          >
            {formatMoney(row.amount)}
          </dd>
        </div>
      ))}
    </dl>
  )
}
